export const AutocompleteSize = {
  SMALL: 'small',
  LARGE: 'large',
};

export const PinnedPosition = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

export const PINNED_LABEL_RULES = {
  [PinnedPosition.TOP]: [
    { equals: ['me'] },
    { equals: ['all'], startsWith: ['all '] },
    { equals: ['national'] },
    { equals: ['none', 'unassigned'], startsWith: ['no '] },
  ],
  [PinnedPosition.BOTTOM]: [
    { equals: ['other'] },
    { equals: ['add new', 'create new'], startsWith: ['add new', 'create new'] },
  ],
};
